export default "__VITE_ASSET__BeFtXVGc__"